/**
 * 全局常量配置
 */

/**
 * 布局配置
 */
export const LAYOUT_CONFIGS = {
  '1': { layout: '1' as const, charts: [1], gridClass: 'layout-1' },
  '2V': { layout: '2V' as const, charts: [1, 2], gridClass: 'layout-2v' },
  '2H': { layout: '2H' as const, charts: [1, 2], gridClass: 'layout-2h' },
  '3': { layout: '3' as const, charts: [1, 2, 3], gridClass: 'layout-3' },
  '4': { layout: '4' as const, charts: [1, 2, 3, 4], gridClass: 'layout-4' },
} as const;

/**
 * Binance 时间周期映射
 */
export const BINANCE_INTERVAL_MAP = {
  '1': '1m',
  '5': '5m',
  '15': '15m',
  '30': '30m',
  '60': '1h',
  '240': '4h',
  'D': '1d',
  'W': '1w',    // ⭐ 周线（周一00:00 UTC）
  'M': '1M',    // ⭐ 月线（每月1日00:00 UTC，注意币安使用大写M）
} as const;

/**
 * 默认图表配置
 */
export const DEFAULT_CHART_CONFIG = {
  symbol: 'BTCUSDT',
  interval: '5' as const,
  chartType: 'candlestick' as const,
  dataSource: 'binance' as const,
};

/**
 * 默认同步设置
 */
export const DEFAULT_SYNC_SETTINGS = {
  crosshair: true,
  timescale: true,
  symbol: false,
  interval: false,
  indicator: true,
};

/**
 * 默认图表设置
 */
export const DEFAULT_CHART_SETTINGS = {
  colorScheme: 'international' as const,
  candleStyle: 'filled' as const,
  showVertGridLines: true,
  showHorzGridLines: true,
  showTradeMarkers: true,
  showPositionLines: true,
  crosshairMode: 'normal' as const,
};

/**
 * 颜色主题
 */
export const COLOR_SCHEMES = {
  international: {
    upColor: '#26a69a',
    downColor: '#ef5350',
    wickUpColor: '#26a69a',
    wickDownColor: '#ef5350',
    borderUpColor: '#26a69a',
    borderDownColor: '#ef5350',
  },
  china: {
    upColor: '#ef5350',
    downColor: '#26a69a',
    wickUpColor: '#ef5350',
    wickDownColor: '#26a69a',
    borderUpColor: '#ef5350',
    borderDownColor: '#26a69a',
  },
};

/**
 * 图表主题配置
 */
export const CHART_THEME = {
  layout: {
    background: { color: '#0d1117' },
    textColor: '#d1d4dc',
  },
  grid: {
    vertLines: { color: '#1e2329' },
    horzLines: { color: '#1e2329' },
  },
  crosshair: {
    mode: 2 as const, // ⭐ 默认隐藏（2 = Hidden），由 ChartManager 控制
    vertLine: {
      width: 1 as const,
      color: '#758696',
      style: 0 as const, // ⭐ 0 = 实线，3 = 虚线
      labelBackgroundColor: '#2962ff',
    },
    horzLine: {
      width: 1 as const,
      color: '#758696',
      style: 0 as const, // ⭐ 0 = 实线，3 = 虚线
      labelBackgroundColor: '#2962ff',
    },
  },
  timeScale: {
    borderColor: '#2b2b43',
    timeVisible: true,
    secondsVisible: false,
  },
  rightPriceScale: {
    borderColor: '#2b2b43',
    minimumWidth: 80,
    width: 80,  // ⭐ 固定右側座標軸寬度，不隨數字長度變化
  },
};

/**
 * WebSocket 配置
 */
export const WEBSOCKET_CONFIG = {
  reconnectDelay: 5000,
  maxReconnectAttempts: 3,
  pingInterval: 30000,
};

/**
 * API 配置
 */
export const API_CONFIG = {
  binanceRestApi: 'https://api.binance.com/api/v3',
  binanceWsApi: 'wss://stream.binance.com:9443/ws',
  requestTimeout: 10000,
  cacheExpiry: 24 * 60 * 60 * 1000, // 24 hours
};

/**
 * 交易配置
 */
export const TRADING_CONFIG = {
  minLeverage: 1,
  maxLeverage: 100,
  defaultLeverage: 10,
  minQuantity: 0.001,
  maxQuantity: 1000,
  defaultQuantity: 0.1,
  quickAmounts: [0.25, 0.5, 0.75, 1.0],
};

/**
 * 风控配置
 */
export const RISK_CONFIG = {
  maxLeverage: 100,
  maxPositionSize: 10,
  maxOpenOrders: 20,
  minOrderSize: 0.001,
  maxOrderSize: 100,
  warningThreshold: 0.8, // 80% of limit
};

/**
 * 手续费配置
 */
export const FEE_CONFIG = {
  makerFee: 0.0002, // 0.02%
  takerFee: 0.0004, // 0.04%
};

/**
 * 性能配置
 */
export const PERFORMANCE_CONFIG = {
  debounceDelay: 300,
  updateInterval: 2000,
  maxCandleHistory: 500,
  enableIncrementalCalculation: true,
};

/**
 * LocalStorage 键名
 */
export const STORAGE_KEYS = {
  chartSettings: 'chartSettings',
  syncSettings: 'syncSettings',
  layoutSettings: 'layoutSettings',
  favoriteSymbols: 'favorite_symbols',
  binanceSymbolsCache: 'binance_symbols_cache',
  heightRatios: 'chart-{id}-height-ratios',
  sectionRatio: 'section-ratio',
  accountInfo: 'accountInfo',
  tradingHistory: 'tradingHistory',
};

/**
 * 调试配置
 */
export const DEBUG_CONFIG = {
  enabled: false, // 生产环境设为 false
  logLevel: 'warn' as 'log' | 'warn' | 'error',
  showPerformanceMetrics: false,
};

